var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWedding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wedding_ytf6fi6j3e2t 1"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M90 87.245H0V90H90V87.245Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.18229 66.1425H2.80469V85.8145H5.55971V68.9718C11.9144 69.6604 16.8774 75.0579 16.8774 81.5926V85.8143H19.6324V81.5927C19.6326 73.0733 12.7017 66.1425 4.18229 66.1425Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.26523 61.898H0V64.653H8.26523V61.898Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2.80469 29.5536V60.4837H5.55971V32.3088H25.3207V39.3748C25.3207 49.4787 17.1006 57.699 6.99654 57.699V60.454C18.6197 60.4538 28.0761 50.9978 28.0761 39.3747V29.5534L2.80469 29.5536Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.2037 35.2653H8.44873V54.7346H11.2037V35.2653Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M11.2037 73.102H8.44873V85.7755H11.2037V73.102Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M85.8038 66.1425C77.2846 66.1425 70.3535 73.0733 70.3535 81.5927V85.8145H73.1085V81.5927C73.1085 75.0579 78.0714 69.6605 84.4262 68.972V85.8147H87.1812V85.8145V66.1425H85.8038Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M90.0001 61.898H81.7349V64.653H90.0001V61.898Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M61.9102 29.5536V39.3748C61.9102 50.9978 71.3661 60.4542 82.9895 60.4542V57.6992C72.8856 57.6992 64.6653 49.4791 64.6653 39.375V32.309H84.4262V60.4839H87.1813V29.5536H61.9102Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M81.5509 35.2653H78.7959V54.7346H81.5509V35.2653Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M81.5509 73.102H78.7959V85.7755H81.5509V73.102Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M45.3186 0H41.8321L1.46924 21.6633V28.102H88.5305V21.6367L45.3186 0ZM42.5245 2.75502H44.6673L50.1696 5.51004H37.3914L42.5245 2.75502ZM85.7753 25.347H4.22443V23.8776H38.0203V21.1226H8.30326L32.3264 8.22885V8.26541H55.6721L81.3499 21.1226H51.9795V23.8776H85.7753V25.347Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M49.2243 21.1224H40.7754V23.8774H49.2243V21.1224Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M29.3877 29.5715V32.3266H30.857V42.2448H39.4897V32.3266H40.7753V42.2448H49.2243V32.3266H50.5099V42.2448H59.1425V32.3266H60.6119V29.5715H29.3877ZM36.7346 39.4898H33.6122V32.3266H36.7346V39.4898ZM46.4692 39.4898H43.5305V32.3266H46.4692V39.4898ZM56.3877 39.4898H53.2651V32.3266H56.3875V39.4898H56.3877Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M61.6764 53.1684C59.5557 51.0478 56.7359 49.8797 53.7367 49.8797C50.7375 49.8797 47.9178 51.0478 45.797 53.1684L45.7759 53.1893L45.755 53.1684C43.6344 51.0478 40.8145 49.8797 37.8153 49.8797C34.8161 49.8797 31.9964 51.0478 29.8756 53.1684C27.755 55.289 26.5869 58.1089 26.5869 61.1081C26.5869 64.1073 27.755 66.927 29.8756 69.0478L45.7761 84.9482L61.6764 69.0478C63.797 66.9271 64.9651 64.1073 64.9651 61.1081C64.9651 58.1087 63.7972 55.289 61.6764 53.1684ZM59.7285 67.0998L45.7763 81.0519L31.8241 67.0998C28.52 63.7958 28.52 58.4202 31.8238 55.1166C33.4758 53.4646 35.6455 52.6388 37.8155 52.6388C39.9851 52.6388 42.1552 53.4648 43.8071 55.1168L45.7763 57.0857L47.7454 55.1166C49.3457 53.5163 51.4735 52.6347 53.737 52.6347C56.0002 52.6347 58.128 53.5159 59.7287 55.1166C61.329 56.7169 62.2106 58.8447 62.2106 61.1083C62.2104 63.3714 61.329 65.4993 59.7285 67.0998Z",
    fill: "#222222"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_85"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    rx: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWedding);
export default __webpack_public_path__ + "static/media/icon-wedding.0be79f8c7a7afa9a27018a428bf484ae.svg";
export { ForwardRef as ReactComponent };